import { format, parseISO } from 'date-fns';
import { CouponScopeLabels } from '../../../api/payments/coupons/domain/labels';

export function formatExpiresAt(expiresAt) {
  if (!expiresAt) return 'Sem data de expiração';
  return format(parseISO(expiresAt), 'dd/MM/yyyy');
}

export function formatCycles(cyclesCount) {
  const count = Number(cyclesCount) || 0;
  return `${count} ${count === 1 ? 'ciclo' : 'ciclos'}`;
}

export function formatAppliesTo(coupon) {
  const discounts = coupon?.discounts ?? [];
  if (!discounts.length) {
    return '-';
  }
  return discounts.reduce((acc, discount) => {
    const label = CouponScopeLabels[discount.scope];
    if (!label) return acc;
    return acc.length ? acc.concat(' - ', label) : acc.concat(label);
  }, '');
}

export function formatDiscount(coupon) {
  const value = coupon.discountValue ?? coupon.value;
  const valueType = coupon.discountValueType ?? coupon.valueType;
  if (value === undefined || value === null) return '-';
  return valueType === 'PERCENT' ? `${value}%` : `R$${value}`;
}

export function getInitialParams(search) {
  const params = new URLSearchParams(search);
  const page = Number(params.get('page')) || 1;
  const perPage = Number(params.get('perPage')) || 10;
  const code = params.get('code') || '';
  return { page, perPage, code };
}
